import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import PropTypes from 'prop-types';
import { useDotLottie } from '../hooks/useDotLottie';

export default function CustomizationVisual({ data, selection, step }) {
	const { animationData, subtitle } = useDotLottie({ data, selection, step });

	return (
		<>
			<div className="visual__animation">
				<DotLottieReact key={`${JSON.stringify(animationData)}`} autoplay loop data={animationData} />
			</div>
			<div className="visual__text">{subtitle}</div>
		</>
	);
}

CustomizationVisual.propTypes = {
	data: PropTypes.object.isRequired,
	selection: PropTypes.array.isRequired,
	step: PropTypes.number.isRequired,
};
